
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soft/atoms/japan/catcher",
      function () {
        return require("private-next-pages/soft/atoms/japan/catcher/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soft/atoms/japan/catcher"])
      });
    }
  